import { render } from "./COPOPSO.vue?vue&type=template&id=15f3b2a9&scoped=true"
import script from "./COPOPSO.vue?vue&type=script&lang=js"
export * from "./COPOPSO.vue?vue&type=script&lang=js"

import "./COPOPSO.vue?vue&type=style&index=0&id=15f3b2a9&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15f3b2a9"]])

export default __exports__